module.exports = __webpack_public_path__ + "img/pen.0cad40b2.svg";